import Icon, { IconProps } from './Icon';

import MicrophoneIcon from '../../../assets/icons/microphone-01.svg?react';

const Microphone: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <MicrophoneIcon />
        </Icon>
    );
};

export default Microphone;
